import React from 'react';
import './BioSection.css';

function BioSection() {
    return (
        <section className="bio-section">
            <h2 className="bio-section-title">About the Facilitator</h2>
            <div className="bio-content">
                <img src="https://discoverylearningchat-public-media.s3.ap-southeast-2.amazonaws.com/pic1.jpg" alt="Dr. Damon Whitten" className="bio-image" />
                <div className="bio-text">
                    <h3>Dr Damon Whitten</h3>
                    <p>
                        Damon is a specialist provider of professional development to the tertiary sector, focusing on adult literacy and numeracy.
                        He focuses on generating and connecting research to real-world contexts and using the results to develop effective teaching and learning approaches.
                    </p>
                    <p>
                        Damon is at the forefront of adult education and works toward empowering and reengaging adult learners with their dreams, passions and potentials through numeracy and literacy education.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default BioSection;